// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'a1cbd424-a762-4f74-9267-33417767cc11',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4a1aeb7c-f410-44c0-8a8d-1c4349e59c0f',
      type: 'Sprite',
      name: 'gradient',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'a1cbd424-a762-4f74-9267-33417767cc11'
    },
    {
      id: '07f8ae81-835b-4d30-8d0a-ff8da2a0d76c',
      type: 'Container',
      name: 'contentWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a1cbd424-a762-4f74-9267-33417767cc11'
    },
    {
      id: '6d79e11c-e80b-4121-832c-1e67a0080129',
      type: 'Text',
      name: 'tileReachedText',
      className: '',
      x: 0,
      y: 795,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You reached Tile *<amount>!*',
      localize: true,
      maxWidth: 600,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'right',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a1cbd424-a762-4f74-9267-33417767cc11',
      data: {
        emphasisStyle: {
          fill: '#00f5ff',
          fontSize: 72
        }
      }
    },
    {
      id: 'f944abfc-18a7-4e6a-8592-fc0d4de6a9d6',
      type: 'Container',
      name: 'popupContainer',
      className: '',
      x: 0,
      y: 440,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07f8ae81-835b-4d30-8d0a-ff8da2a0d76c'
    },
    {
      id: 'ce9b4c57-826f-49bc-9435-b19ddce6d7d9',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 1061,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07f8ae81-835b-4d30-8d0a-ff8da2a0d76c'
    },
    {
      id: '4de809e0-bdac-4d4a-92c5-3302d76044a5',
      type: 'Container',
      name: 'shareContainer',
      className: '',
      x: -271,
      y: -289,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f944abfc-18a7-4e6a-8592-fc0d4de6a9d6'
    },
    {
      id: '502590c5-8b3d-4bae-8c2c-6dabc8a957aa',
      type: 'Sprite',
      name: 'shareFrame',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Pop_Up',
      parent: 'f944abfc-18a7-4e6a-8592-fc0d4de6a9d6'
    },
    {
      id: 'b9cbce10-db33-4042-a4dc-26f8d7afb650',
      type: 'Text',
      name: 'closeButton',
      className: '',
      x: 0,
      y: 132,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: -2000,
        width: 2000,
        height: 4000
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ce9b4c57-826f-49bc-9435-b19ddce6d7d9'
    },
    {
      id: '385a4915-7104-4ea9-abd7-4cd5b8950bb9',
      type: 'Layout',
      name: 'shareButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: 'ce9b4c57-826f-49bc-9435-b19ddce6d7d9',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '3e37e754-46d6-44a2-8714-c61c576c3313',
      type: 'Sprite',
      name: '',
      className: 'userAvatar_SPL',
      x: 184,
      y: 138,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3.5,
        y: 3.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '4de809e0-bdac-4d4a-92c5-3302d76044a5'
    },
    {
      id: '73445156-bf2c-44fb-81c1-b1193de064fe',
      type: 'Sprite',
      name: 'shareImage',
      className: '',
      x: 271,
      y: 282,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.52,
        y: 0.52
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Win_Streak_Post',
      parent: '4de809e0-bdac-4d4a-92c5-3302d76044a5'
    },
    {
      id: '4d45afbc-7189-475b-b5cc-e2002aadc7b4',
      type: 'Text',
      name: 'progressText',
      className: '',
      x: 271,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '80',
      localize: false,
      maxWidth: 250,
      maxHeight: 200,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 110,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x0060d7',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 7,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '4de809e0-bdac-4d4a-92c5-3302d76044a5'
    },
    {
      id: 'a32c5b63-749f-46cc-ad56-335c9ae397ef',
      type: 'Sprite',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Facebook_Icon',
      parent: '385a4915-7104-4ea9-abd7-4cd5b8950bb9'
    },
    {
      id: '7f81d1c4-1319-44f6-b43c-1e0c76e5e682',
      type: 'Text',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 232,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x0047af',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '385a4915-7104-4ea9-abd7-4cd5b8950bb9'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 1280,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakSharePopupLayout {
  static raw = raw;
  root!: Container;
  gradient!: Sprite;
  contentWrapper!: Container;
  tileReachedText!: Text & { data: typeof raw['list'][3]['data'] };
  popupContainer!: Container;
  buttonContainer!: Container;
  shareContainer!: Container;
  shareFrame!: Sprite;
  closeButton!: Text;
  shareButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][9]['data'] };
  shareImage!: Sprite;
  progressText!: Text;
  userAvatar_SPL!: (Sprite)[];
  center_SPL!: (Sprite | Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
